"use strict";

define('components/filter_bar/table/manage_views',[], function() {
    var manageViewsComponent = {
        initWithContext: function(context) {
            _initData(context);
            
            var tableSettingsInstance = context.tableFilterBarData.tableSettingsInstance;
            var settingsModal = $('#settings-modal');

            function showSettingsModal(contentHTML) {
                settingsModal.find('.modal-content')
                             .html(contentHTML);
   
                settingsModal.trigger('loaded.bs.modal');

                settingsModal.modal({
                    show: true,
                    backdrop: 'static'
                });
            }

            var chooseColumnsLink = context.manageViewsData.chooseColumnsLink;
            chooseColumnsLink.click(function(e) {
                e.preventDefault();

                var url = chooseColumnsLink.attr('href');
                $.get(url, function(data) {
                    showSettingsModal(data);
                    tableSettingsInstance.initChooseColumns(settingsModal);
                });
            });

            var saveCurrentViewLink = context.manageViewsData.saveCurrentViewLink;
            saveCurrentViewLink.click(function(e) {
                e.preventDefault();

                if (saveCurrentViewLink.hasClass('disabled')) return;

                var url = saveCurrentViewLink.attr('href');
                $.get(url, function(data) {
                    showSettingsModal(data);
                    tableSettingsInstance.initSaveCurrentView(settingsModal);
                });
            });

            var deleteCurrentViewLink = context.manageViewsData.deleteCurrentViewLink;
            deleteCurrentViewLink.click(function(e) {
                e.preventDefault();

                if (deleteCurrentViewLink.hasClass('disabled')) return;

                var url = deleteCurrentViewLink.attr('href');
                $.get(url, function(data) {
                    showSettingsModal(data);
                    tableSettingsInstance.initDeleteCurrentView(settingsModal);
                });
            });
        },

        setPersonalized: function(context) {
            _getSelectedViewCheckbox(context).prop('checked', false);

            context.manageViewsData.deleteCurrentViewLink.addClass('disabled');
            context.manageViewsData.saveCurrentViewLink.removeClass('disabled');
        }
    };

    function _initData(context) {
        context.manageViewsData = {
            chooseColumnsLink: context.buttonbarNode.find('.table_settings_choose_columns'),
            deleteCurrentViewLink: context.containerNode.find('a.table_settings_delete_current_view'),
            saveCurrentViewLink: context.containerNode.find('a.table_settings_save_current_view')
        };
    }

    function _getSelectedViewCheckbox(context) {
        return context.containerNode.find('input[name="selected_table_settings_id"]:checked');
    }

    return manageViewsComponent;
});

